if (!customElements.get('sun365-powerhub-promotion')) {
  class Sun365PowerHubPromotion extends HTMLElement {
    static request;

    connectedCallback() {
      this.hidden = true;
      if (!Sun365PowerHubPromotion.request) {
        Sun365PowerHubPromotion.request = this.loadQuantity();
      }
      Sun365PowerHubPromotion.request.then((result) => {
        if (!this.isConnected || !result || result.count <= 0) return;
        this.querySelector('[data-promo-count]').textContent = result.count.toLocaleString(this.dataset.locale || 'de-DE');
        this.querySelector('[data-promo-quantity]').hidden = false;
        this.querySelector('[data-promo-source]').hidden = false;
        const checked = this.querySelector('[data-promo-checked]');
        checked.dateTime = result.checked.toISOString();
        checked.textContent = result.checked.toLocaleString(this.dataset.locale || 'de-DE', {
          day: '2-digit', month: '2-digit', year: 'numeric', hour: '2-digit', minute: '2-digit', timeZone: 'Europe/Berlin'
        }) + ' (Berlin)';
        this.hidden = false;
      }).catch(() => {
        this.hidden = true;
      });
    }

    async loadQuantity() {
      const controller = new AbortController();
      const timeout = setTimeout(() => controller.abort(), 7000);
      try {
        const response = await fetch('https://www.zendure.de/pages/zendure-aktionshinweise', {
          credentials: 'omit', referrerPolicy: 'no-referrer', cache: 'no-store', signal: controller.signal
        });
        if (!response.ok) return null;
        const html = await response.text();
        const source = new DOMParser().parseFromString(html, 'text/html');
        const content = source.querySelector('main .rte')?.textContent || '';
        if (!/Powerhub Geschenkaktion/i.test(content)) return null;
        const match = content.match(/Aktuell\s+noch\s+verfügbar:\s*([\d.]+)\s*Stück/i);
        if (!match) return null;
        const count = Number(match[1].replace(/\./g, ''));
        if (!Number.isInteger(count) || count < 0 || count > 1000) return null;
        return { count, checked: new Date() };
      } catch {
        return null;
      } finally {
        clearTimeout(timeout);
      }
    }
  }
  customElements.define('sun365-powerhub-promotion', Sun365PowerHubPromotion);
}

